import { render, staticRenderFns } from "./ListProjects.vue?vue&type=template&id=f165d966&scoped=true"
import script from "./ListProjects.vue?vue&type=script&lang=js"
export * from "./ListProjects.vue?vue&type=script&lang=js"
import style0 from "./ListProjects.vue?vue&type=style&index=0&id=f165d966&prod&scoped=true&lang=css"
import style1 from "./ListProjects.vue?vue&type=style&index=1&id=f165d966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f165d966",
  null
  
)

export default component.exports